import React, { useEffect, useState } from "react";
import {
  Box,
  MenuItem,
  Menu,
  CircularProgress
} from "@mui/material";
import GroupLoansTable from "../GroupLoansTable/GroupLoansTable";
import GroupLoansCheckProperties from "../../pages/GroupLoans/GroupLoansCheckProperties/GroupLoansCheckProperties";
import GroupLoansTnC from "../../pages/GroupLoans/GroupLoansTnC/GroupLoansTnC";
import GroupLoansRules from "../../pages/GroupLoans/GroupLoansRules/GroupLoansRules";
import GroupLoansBalances from "../../pages/GroupLoans/GroupLoansBalances/GroupLoansBalances";
import GroupLoansPendingApprovals from "../../pages/GroupLoans/GroupLoansPendingApprovals/GroupLoansPendingApprovals";
import { commonRunQuery } from "../../util/API/loans";
import GroupLoansListMembers from "../../pages/GroupLoans/GroupLoansListMembers/GroupLoansListMembers";
import GroupLoansListMembersWithLoans from "../../pages/GroupLoans/GroupLoansListMembersWithLoans/GroupLoansListMembersWithLoans";
import { useSelector } from "react-redux";

function GroupsOwnedTab({ selectedUser, selectedUserData }) {
    const [groupsOwned, setGroupsOwned] = useState([]);
    const [anchorEl, setAnchorEl] = useState(null);
    const [selectedLoan, setSelectedLoan] = useState(null);
    const [selectedView, setSelectedView] = useState(null);
    const [loading, setLoading] = useState(true);

    const user = useSelector((state) => state.usersList.userID);

    console.log("user=======",user?.User?.id);

    useEffect(() => {
        getListOfGroupsOwned();
    }, [selectedUser]);

    const getListOfGroupsOwned = async() => {
        try {
            const response = await commonRunQuery(284, user?.User?.id);
            if ( response?.data?.header?.callStatus === "1" && response?.data?.header?.reccount !== "0" ) {
                const groupsArray = Array.isArray(response?.data?.body?.record)
                        ? response?.data?.body?.record
                        : [response?.data?.body?.record];
      
                setGroupsOwned(groupsArray);
              console.log("getListOfGroupsOwned_response==========",groupsArray);
            } else {
                setGroupsOwned([]);
            }
        } catch (error) {
            console.log("getListOfGroupsOwned_error==========",error);
        } finally {
            setLoading(false)
        }
    }

    const columns = [
        {
            label: 'Group ID',
            getValue: (row) => row?.loangroups?.groupid ?? ''
        },
        {
            label: 'Group Name',
            getValue: (row) => row?.loangroups?.groupname ?? ''
        },
        // {
        //     label: 'Duration (months)',
        //     getValue: (row) => row?.loangroups?.durationinmonths ?? ''
        // },
        {
            label: 'No. Of Members',
            getValue: (row) => row?.loangroups?.noofmembers ?? ''
        },
        {
            label: 'Status',
            getValue: (row) => row?.loangroups?.status == "1" ? "Active" : "Closed"
        },
        // {
        //     label: 'Interest Rate',
        //     getValue: (row) => row?.loangroups?.interestrateforloans ?? ''
        // }
    ];

    const handleMenuOpen = (event, loan) => {
        console.log("handleMenuOpen------------",loan)
        setAnchorEl(event.currentTarget);
        setSelectedLoan(loan);
    };

    const handleMenuClose = () => {
        console.log("handleMenuClose------------")
        setAnchorEl(null);
    };

    const formatedRows = (row) => columns.map((column) => column.getValue(row));

    return (
        <Box className="groups-owned-tab-container" p={2}>

                {loading ? (
                    <Box
                        sx={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        width: "100%",
                        overflow: "hidden",
                        }}
                    >
                        <CircularProgress />
                    </Box>
                ) :
                (
                    <>
                        {
                            selectedView == null &&
                            <Box>
                                <GroupLoansTable 
                                    data={groupsOwned} 
                                    columns={columns} 
                                    title="Groups Owned" 
                                    formatRow={formatedRows} 
                                    handleMenuOpen={handleMenuOpen}
                                    viewMenu={true}
                                    downloads={false}
                                    // author={`${user?.user?.firstName} ${user?.user?.lastName}`} 
                                />
                            </Box>
                        }
                    </>
                )}


            {selectedView === 'checkProperties' && <GroupLoansCheckProperties selectedLoan={selectedLoan} setSelectedView={setSelectedView} />}
            {selectedView === 'viewTerms' && <GroupLoansTnC selectedLoan={selectedLoan} setSelectedView={setSelectedView} />}
            {/* {selectedView === 'viewRules' && <GroupLoansRules selectedLoan={selectedLoan} setSelectedView={setSelectedView} />} */}
            {selectedView === 'groupBalances' && <GroupLoansBalances selectedLoan={selectedLoan} setSelectedView={setSelectedView} />}
            {selectedView === 'listMembers' && <GroupLoansListMembers selectedLoan={selectedLoan} setSelectedView={setSelectedView} selectedView={selectedView} showMoreDetails={true} />}
            {selectedView === 'pendingApprovals' && <GroupLoansPendingApprovals selectedLoan={selectedLoan} setSelectedView={setSelectedView} />}
            {selectedView === 'piGroups' && <GroupLoansCheckProperties selectedLoan={selectedLoan} setSelectedView={setSelectedView} />}
            {selectedView === 'listMembersWithLoans' && <GroupLoansListMembersWithLoans selectedLoan={selectedLoan} setSelectedView={setSelectedView} selectedView={selectedView} />}
            
            <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleMenuClose}>
                <MenuItem
                    onClick={() => {
                        setSelectedView('checkProperties');
                        handleMenuClose();
                    }}
                >
                    Check Properties
                </MenuItem>
                <MenuItem
                    onClick={() => {
                        setSelectedView('viewTerms');
                        handleMenuClose();
                    }}
                >
                    View T&C
                </MenuItem>
                {/* <MenuItem
                    onClick={() => {
                        setSelectedView('viewRules');
                        handleMenuClose();
                    }}
                >
                    View Rules
                </MenuItem> */}
                <MenuItem
                    // disabled={selectedLoan?.outstandingamountwithlatefee <= 0}
                    onClick={() => {
                        setSelectedView('groupBalances');
                        handleMenuClose();
                    }}
                >
                    View Group Balances
                </MenuItem>
                <MenuItem
                    // disabled={selectedLoan?.outstandingamountwithlatefee <= 0}
                    onClick={() => {
                        setSelectedView('listMembers');
                        handleMenuClose();
                    }}
                >
                    List Members
                </MenuItem>
                <MenuItem
                    onClick={() => {
                        setSelectedView('listMembersWithLoans');
                        handleMenuClose();
                    }}
                >
                    List Members With Loans
                </MenuItem>
                <MenuItem
                    onClick={() => {
                        setSelectedView('pendingApprovals');
                        handleMenuClose();
                    }}
                >
                    Pending Approvals
                </MenuItem>
                <MenuItem
                    onClick={() => {
                        setSelectedView('piGroups');
                        handleMenuClose();
                    }}
                >
                    PI Groups
                </MenuItem>
            </Menu>
        </Box>
    );
}

export default GroupsOwnedTab;
